import { AxiosRequestConfig, AxiosInstance, AxiosResponse } from "axios"

export interface SaveGAIdRequest extends Partial<AxiosRequestConfig> {
  params: {
    id: string
  }
}

export interface SaveGAIdResponse extends AxiosResponse {
  data: string
}

export function saveGAIdApi(
  { params, method = "get", ...config }: SaveGAIdRequest,
  axiosInstance: AxiosInstance,
): Promise<SaveGAIdResponse> {
  return axiosInstance({
    params,
    method,
    url: "/user/save-gaid",
    ...config,
  }) as Promise<SaveGAIdResponse>
}
